import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Courses from "./pages/Courses";
import HomePage from "./pages/Home";
import SeatAllocation from "./pages/SeatAllocations";
import Sessions from "./pages/Sessions";
import ProtectedLayout from "./layout/ProtectedLayout";
import ManagerCourseApplications from "./pages/Manager";
import ManagerApplications from "./pages/Manager/CourseApplications";
import AvailableTrainings from "./pages/Learner/AvailableTrainings";
import ApplicationStatus from "./pages/Learner/ApplicationStatus";
import CourseSessions from "./pages/Learner/AvailableTrainings/CourseSessions"; //c
import MyTrainingHistory from "./pages/Learner/MyTrainingHistory";
import AllTrainings from "./pages/Hr/AllTrainings";
import CourseApplications from "./pages/Hr/AllTrainings/CourseApplications";
import UserApplication from "./pages/Hr/UserApplications";
import HrApprovals from "./pages/Hr/HrApprovals";
import TrainingCost from "./pages/Admin/TrainingCost";
import TeamApplications from "./pages/Manager/TeamApplications";
import ManagerApplyForTeam from "./pages/Manager/ApplyForTeam";
import ManagerApplyForTeamApplications from "./pages/Manager/ApplyForTeam/CourseApplications";
import HRTrainingCost from "./pages/Hr/TrainingCost";
import HRCourses from "./pages/Hr/SeatAllocation";
import HRSessions from "./pages/Hr/SeatAllocation/CourseSessions";
import HRSeatAllocation from "./pages/Hr/SeatAllocation/SeatAllocation";
import AdminAuditTrail from "./pages/Admin/AuditTrail";
import HrAuditTrail from "./pages/Hr/AuditTrail";
import AdminReports from "./pages/Admin/Reports";
import HrReports from "./pages/Hr/Reports";

function App() {
  return (
    <div className="w-full p-6 md:w-4/5 m-auto md:px-40 md:py-16">
      <BrowserRouter>
        <Routes>
          <Route path={"/"} element={<ProtectedLayout />}>
            <Route path={"/"} element={<HomePage />} />
            <Route path={"/manager"} element={<ManagerCourseApplications />} />
            <Route
              path={"/manager/courses/:id"}
              element={<ManagerApplications />}
            />
            <Route
              path={"/manager/team-applications"}
              element={<TeamApplications />}
            />
            <Route
              path={"/manager/apply-for-team"}
              element={<ManagerApplyForTeam />}
            />
            <Route
              path={"/manager/apply-for-team/:id"}
              element={<ManagerApplyForTeamApplications />}
            />
            <Route
              path={"/learner/available-trainings"}
              element={<AvailableTrainings />}
            />
            <Route
              path={"/learner/available-trainings/:id"}
              element={<CourseSessions />}
            />
            <Route
              path={"/learner/applied-trainings"}
              element={<ApplicationStatus />}
            />

            <Route
              path={"/learner/my-trainings-history"}
              element={<MyTrainingHistory />}
            />
            <Route path={"/courses"} element={<Courses />} />
            <Route path={"/courses/sessions/:id"} element={<Sessions />} />
            <Route
              path={"/courses/sessions/:id/seat-allocation/:id"}
              element={<SeatAllocation />}
            />

            <Route path={"/admin/training-cost"} element={<TrainingCost />} />
            <Route path={"/admin/audit-trail"} element={<AdminAuditTrail />} />
            {/* <Route path={"/admin/reports"} element={<AdminReports />} /> */}

            {/* ====================== HR ================================== */}
            <Route path={"/hr/all-trainings"} element={<AllTrainings />} />
            <Route
              path={"/hr/all-training/course-applications/:id"}
              element={<CourseApplications />}
            />
            <Route
              path={"/hr/user-applications"}
              element={<UserApplication />}
            />
            <Route
              path={"/hr/hr-approvals"}
              element={<HrApprovals />}
            />
            <Route path={"/hr/seat-allocations"} element={<HRCourses />} />
            <Route path={"/hr/training-costs"} element={<HRTrainingCost />} />
            <Route path={"/hr/audit-trail"} element={<HrAuditTrail />} />
            {/* <Route path={"/hr/reports"} element={<HrReports />} /> */}
            <Route path={"/hr/courses/sessions/:id"} element={<HRSessions />} />
            <Route
              path={"/hr/courses/sessions/:id/seat-allocation/:id"}
              element={<HRSeatAllocation />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
